import React, { useEffect, useState } from "react";
import { Truck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const inputCls = "w-20 rounded-xl border-2 border-[#19324A]/10 px-3 py-2 text-sm outline-none focus:border-[#FFD93D]";
const Num = ({ label, value, onChange, testid }) => (
  <label className="block"><span className="block text-xs font-semibold text-[#19324A]/60 mb-1">{label}</span>
    <input type="number" min="0" max="30" value={value} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={testid} /></label>
);

export default function DeliveryEstimateCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/delivery-estimate").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  const setZone = (z, i, v) => setS((x) => ({ ...x, [z]: x[z].map((d, j) => (j === i ? v : d)) }));
  const save = async () => {
    try { const { data } = await api.put("/admin/delivery-estimate", s); setS(data); toast.success("Delivery estimates updated"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <div className="bg-white rounded-3xl soft-shadow p-6 mb-4" data-testid="delivery-card">
      <h3 className="font-display font-bold text-[#19324A] mb-1 inline-flex items-center gap-2"><Truck className="w-4 h-4 text-[#4CC9F0]" /> "Arrives by" estimates</h3>
      <p className="text-xs text-[#19324A]/50 mb-4">Business days used for the postcode estimate on every product page. Handling + delivery window = the dates shoppers see.</p>
      <p className="text-xs font-bold uppercase tracking-wider text-[#19324A]/45 mb-2">Handling (before it ships)</p>
      <div className="flex flex-wrap gap-4">
        <Num label="In-stock items" value={s.stock_days} onChange={(v) => setS({ ...s, stock_days: v })} testid="delivery-stock-days" />
        <Num label="Personalised (in-house)" value={s.in_house_days} onChange={(v) => setS({ ...s, in_house_days: v })} testid="delivery-inhouse-days" />
        <Num label="Print-on-demand" value={s.pod_days} onChange={(v) => setS({ ...s, pod_days: v })} testid="delivery-pod-days" />
      </div>
      <p className="text-xs font-bold uppercase tracking-wider text-[#19324A]/45 mt-5 mb-2">Delivery window by zone (min – max)</p>
      <div className="flex flex-wrap gap-4">
        {["metro", "regional", "remote"].map((z) => (
          <div key={z} className="flex items-end gap-2">
            <Num label={`${z[0].toUpperCase()}${z.slice(1)} min`} value={s[z][0]} onChange={(v) => setZone(z, 0, v)} testid={`delivery-${z}-min`} />
            <span className="pb-2 text-[#19324A]/40">–</span>
            <Num label="max" value={s[z][1]} onChange={(v) => setZone(z, 1, v)} testid={`delivery-${z}-max`} />
          </div>
        ))}
      </div>
      <button onClick={save} className="btn-pink !py-2 mt-4" data-testid="delivery-save">Save estimates</button>
    </div>
  );
}
